import axios from 'axios';

const axiosInstance = axios.create();

export const getAxios = (): ReturnType<typeof axios.create> => {
    return (window as any).soixa ?? axiosInstance;
};
